/* tslint:disable */

export class ConditionalBehaviourRule {
		Id: number;
		StepId: number;
		SectionId: number;
		QuestionId: number;
		Show: boolean;
		IfQuestionId: number;
		IfQuestionAnswer: string;
		IfExecutionDecisionId: number;
		IfExecutionIntermediateResultBusinessDataId: number;
		IfExecutionResult: string;

}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/ConditionalBehaviourRule.ts